import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const clientPaymentPlan = props.clientPaymentPlan;
  const setEditMode = props.setEditMode;

  return (
    <Stack
      direction={'column'}
      sx={{
        'display': 'flex',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={setEditMode}
    >
      <Box sx={{mr: 1}}>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression={'client.ClientDetail.Payment.PaymentPlan.StripeIdTitle'}
          />
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          {clientPaymentPlan?.stripeCustomerId ?
            clientPaymentPlan.stripeCustomerId:
            <Translate
              expression='client.ClientDetail.Payment.PaymentPlan.NoStripeId'
            />
          }
        </Typography>
      </Box>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
